<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" size="tiny">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="name" label="Nom Prénom">
            <el-input placeholder="Nom Prénom" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="Email">
            <el-input placeholder="Email de la société" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item prop="first_phone" label="Téléphone">
            <el-input placeholder="Téléphone principal" v-model="form.first_phone"></el-input>
          </el-form-item>
          <el-form-item prop="second_phone" label="Téléphone secondaire">
            <el-input placeholder="Téléphone secondaire" v-model="form.second_phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit(false)" :loading="loading">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'contact-modal',
    data () {
      return {
        visible: false,
        loading: false,
        content: {
          title: 'Création d\'un contact',
          button: 'Créer le contact',
          button_type: 'success'
        },
        fields: {
          validation: {
            name: [
              {required: true, message: 'Vous devez saisir un nom'}
            ],
            first_phone: [
              {required: true, message: 'Vous devez saisir un numéro de téléphone'}
            ],
            email: [
              {required: true, message: 'Vous devez saisir une adresse email'}
            ],
          },
        },
        form: {
          user_id: this.$store.getters['users/current'].id,
          customer_id: null,
          source: 'commercial-app',

          // Informations
          name: '',
          first_phone: '',
          second_phone: '',
          email: '',
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.contact.on('create', ({item}) => {
        if (item.customer_id) {
          self.form.customer_id = item.customer_id
        }
        self.visible = true
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            p = self.$model.contact.api().create(this.form)
            
            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// ContactModal.vue?21486bb2